export const computeResetPercent = (completed: number, failed: number, total: number): number => {
  if (total === 0) return 0;
  return Math.round(((completed + failed) / total) * 100);
};

export interface ResetSummary {
  severity: 'success' | 'warn';
  summary: string;
}

export const buildResetSummary = (completed: number, failed: number, total: number): ResetSummary => {
  const noun = completed === 1 ? 'diagnostic' : 'diagnostics';
  if (failed === 0) {
    return { severity: 'success', summary: `Reset ${completed} ${noun}` };
  }
  return { severity: 'warn', summary: `Reset ${completed} of ${total} ${noun}; ${failed} failed` };
};
